import { Component, OnInit, Inject, Renderer2, AfterViewInit, OnDestroy } from '@angular/core';
import { AuthService } from './auth/auth.service';
import { DOCUMENT } from '@angular/common';
import { DirectionService } from './direction.service';
import { TranslateService } from "@ngx-translate/core";

import { DialogService } from './dialog/dialog.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
})
export class AppComponent implements OnInit, OnDestroy, AfterViewInit {

  isRTL: boolean = true;
  key: string;
  language: string = 'he';
  screenHeight = 1;
  private resizeListener = () => this.updateVhConsideringTranslateBar();

  constructor(
    private translate: TranslateService,
    private directionService: DirectionService,
    private authService: AuthService,
    private dialogService: DialogService,
    @Inject(DOCUMENT) private document: Document,
    private render: Renderer2) {
    if (localStorage.getItem('language')) {
      this.language = localStorage.getItem('language');
    }

    // stored language = browser language?
    setTimeout(() => {
      if (!localStorage.getItem('hideLangModel') &&
        (!localStorage.getItem('language') ||
          localStorage.getItem('language') !== 'he')) {
        this.directionService.currentLanguage$.subscribe(lang => {
          const userLang = navigator.language ? navigator.language : null;
          if (userLang && this.language && !userLang.startsWith(this.language)) {
            this.dialogService.onOpenLanguageChangeDialog(
              this.language,
              userLang,
            )
          }
        });
      }
    }, 2000);
    // // stored language = browser language?

    translate.setDefaultLang(this.language);
    translate.use(this.language);
  }

  ngOnInit() {
    this.authService.autoAuthUser();
    this.render.addClass(this.document.body, 'lightTheme');
    this.directionService.direction$.subscribe((direction) => {
      this.isRTL = direction === 'rtl';
    });
  }

  ngAfterViewInit(): void {
    this.updateVhConsideringTranslateBar();
    window.addEventListener('resize', this.resizeListener);
    let tries = 0;
    const intervalId = setInterval(() => {
      this.updateVhConsideringTranslateBar();
      tries++;
      if (tries >= 4) {
        clearInterval(intervalId);
      }
    }, 8000);
  }

  ngOnDestroy(): void {
    window.removeEventListener('resize', this.resizeListener);
  }

  updateVhConsideringTranslateBar(): void {
    const translateHeight = this.getTranslateBannerHeight();
    const placeholder = this.document.getElementById('translate-placeholder');
    if (placeholder) {
      placeholder.style.height = translateHeight ? `${translateHeight}px` : '0';
    }
    const fullHeight = window.innerHeight;
    const effectiveHeight = fullHeight - translateHeight;
    document.documentElement.style.setProperty('--vh', `${effectiveHeight * 0.01}px`);
  }

  getTranslateBannerHeight(): number {
    const iframe =
      document.getElementById('gt-nvframe') as HTMLElement ||
      document.querySelector('iframe[title="Google Translate"]') as HTMLElement ||
      document.querySelector('iframe.goog-te-banner-frame') as HTMLElement ||
      document.querySelector('.goog-te-banner-frame') as HTMLElement;

    let iframeHeight = 0;
    if (iframe) {
      iframeHeight = iframe.getBoundingClientRect().height;
    }

    const bodyMargin = parseFloat(window.getComputedStyle(document.body).marginTop || '0');
    return Math.max(iframeHeight, bodyMargin);
  }

  // ==============
}